const projectCard = {
    tech: 'טכנולוגיות',
    viewImages: 'צפייה בתמונות',
    images: 'תמונות',
};

export default projectCard;
